package gr.tech.pdfgenerator.models

import kotlinx.serialization.Serializable

/*
    REMOVED
    - accountName: Replaced with customerName (Used by MSA, T3)
 */
@Serializable
data class GeneralInputsDTO(
    var companyName: String = "",
    var companyAddress: String = "",
    var companyCity: String = "",
    var companyState: String = "",
    var companyUtility: String = "",
    var companyZip: String = "",
    var companyRepresentative: String = "",
    var facilityAddress: String = "",
    var effectiveDate: String = "",
    var expirationDate: String = "",
    var projectName: String = "",           //Used by Lighting Proposal
    var salesforceDealName: String = "",    //General Save / Key for DB
) {
    override fun toString(): String {
        return """
            |GeneralInputsDTO(
            |  Account Name    : $companyName
            |  State           : $companyState
            |  Comp. Address   : $companyAddress
            |  Facil. Address  : $companyAddress
            |  City            : $companyCity
            |  Zip Code        : $companyZip
            |  Utility         : $companyUtility
            |  Expiration Date : $expirationDate
            |  Effective Date  : $effectiveDate
            |  Project Name    : $projectName
            |  Salesforce Deal : $salesforceDealName
            |)
        """.trimMargin()
    }
}